<template>
  <div class="relative text-black mt-5">
    <date-picker
      v-model="time_range"
      placeholder="Selecteer laatst gezien datums"
      format="DD-MM-YYYY"
      range
      class="lastVerifiedDate"
    ></date-picker>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapActions } from "vuex";

export default {
  name: "LastVerifiedSearch",
  components: { DatePicker },
  computed: {
    time_range: {
      get() {
        return this.$store.state.search["last_verified_range"];
      },
      set(last_verified_range) {
        this.update_search({
          selected: last_verified_range,
          filtername: "last_verified_range"
        });
        if (this.$router.currentRoute.name !== "Home")
          this.$router.push({ name: "Home" });
      }
    }
  },
  methods: {
    ...mapActions(["update_search"])
  }
};
</script>

<style>
.lastVerifiedDate.mx-datepicker .mx-input {
  @apply bg-gray-100 w-full h-10 px-5 pr-10 rounded-lg text-sm  border-gray-700 border font-opensans;
}

.mx-datepicker {
  width: 100%;
}
</style>
